import { useTranslation } from "react-i18next";

export default function ValueSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100 py-14 md:py-20 px-4 md:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-8 font-heading">
          {t("home.value.title")}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          {[1, 2, 3, 4].map((num) => (
            <div
              key={num}
              className="flex items-start gap-4 p-5 md:p-6 bg-background-50 rounded-xl text-left"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-white text-sm font-bold shrink-0 font-body">
                {num}
              </span>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed font-body">
                {t(`home.value.item${num}`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}